import request from './request.js'

/**
 * 不需登录的接口请求
 * @param {Object} config 
 * @returns 
 */
const PublicRequest = config => request({
  ...config,
  public: true,
})

export default PublicRequest